export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/about-us',
    name: '/about-us',
    component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/about-us.vue'),
    /* no children */
  },
  {
    path: '/careers',
    name: '/careers',
    component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/careers.vue'),
    /* no children */
  },
  {
    path: '/contact-us',
    /* internal name: '/contact-us' */
    /* no component */
    children: [
      {
        path: '',
        name: '/contact-us/',
        component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/contact-us/index.vue'),
        /* no children */
      },
      {
        path: 'existing-customer',
        name: '/contact-us/existing-customer',
        component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/contact-us/existing-customer.vue'),
        /* no children */
      },
      {
        path: 'free-demo',
        name: '/contact-us/free-demo',
        component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/contact-us/free-demo.vue'),
        /* no children */
      },
      {
        path: 'partner-up',
        name: '/contact-us/partner-up',
        component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/contact-us/partner-up.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/faq',
    name: '/faq',
    component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/faq.vue'),
    /* no children */
  },
  {
    path: '/free-demo',
    name: '/free-demo',
    component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/free-demo.vue'),
    /* no children */
  },
  {
    path: '/how-it-works',
    name: '/how-it-works',
    component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/how-it-works.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/nysra-demo',
    name: '/nysra-demo',
    component: () => import('/home/ubuntu/jenkins/workspace/RND/Static_Apps_staging_dev/sa-landingPage-staging/src/pages/nysra-demo.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

